import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";
import PoolIcon from "@mui/icons-material/Pool";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/library/Drawer/index.";
import { jwtDecode } from "jwt-decode";
import { getUserDetails } from "../utils/utils";

function MainLayout({ children }) {
  const { token } = getUserDetails();  
  const decoded = token ? jwtDecode(token) : {};

  // All modules which will be sidebar navigation pages.
  const module = [
    {
      moduleName: "Inspection Details",
      icon: <TravelExploreIcon />,
      path: "/inspection-details",
    },
  ];

  if (decoded?.role !== "Client") {
    module.push(
      {
        moduleName: "Pool Details",
        icon: <PoolIcon />,
        path: "/pool-details",
      },
      {
        moduleName: "User Details",
        icon: <PersonIcon />,
        path: "/user-details",
      },
      {
        moduleName: "Deleted User",
        icon: <DeleteIcon />,
        path: "/deleted-user",
      }
    );
  }

  return (
    <>
      <div className="main-container">
        {/* sidebar to navigate between pages */}

        <div className="main-content">
          <div className="page-content">
            <Sidebar modules={module} content={children || <Outlet />} />
          </div>
        </div>
      </div>
    </>
  );
}

export default MainLayout;
